import "./App.css";
import Router from "./router/router.jsx";
import ScrollToTop from "./components/ScrollToTop";
import { useState, useEffect } from "react";
import ProPlanPopup from "./components/ProPlanPopup";
import { shouldShowPopup } from "./utils/proPlanAnnouncement";

function App() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (shouldShowPopup()) {
        setShowPopup(true);
      }
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <ScrollToTop />
      <Router />
      {showPopup && <ProPlanPopup onClose={() => setShowPopup(false)} />}
    </>
  );
}

export default App;

// import "./App.css";
// import Router from "./router/router.jsx";
// import ScrollToTop from "./components/ScrollToTop";


// function App() {
//   return (
//     <>
//       <ScrollToTop />
//       <Router />
//     </>
//   );
// }

// export default App;
